<!-- 一行骨架需要展示多段内容时使用 -->
<script lang="ts">
  import Skeleton from './Skeleton.svelte';

  export let childProps: any[] = [];
  export let height = '32px';

  export {className as class};
  let className = '';
</script>

<style>
  .skeleton-line {
    display: grid;
    align-items: center;
    height: var(--skeleton-line-height);
    grid-template-columns: repeat(var(--skeleton-line-num), auto);
  }
</style>

<div class="skeleton-line {className}" style="--skeleton-line-num: {childProps.length};--skeleton-line-height: {height};">
  {#each childProps as childProp}
    <Skeleton {...childProp} />
  {/each}
</div>
